import { Component, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CompanyService } from '../../services/Company/company.service';
import { RolesService } from '../../services/roles/roles.service'
import { OthersService } from '../../services/others/others.service'
import { ContentLayoutComponent } from '../content-layout/content-layout.component';

import { DataService } from "../../services/data.service";

import * as $ from "jquery";
//import { ConsoleReporter } from 'jasmine';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: '[app-sidebar]',
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss']
})

export class AppSidebar {

  linked: boolean = false;

  listcomps: any;
  defcomp: any;
  showsubmenu: boolean = false;
  message: string;
  compname: string = "";
  compid = 0;
  current:any = null;
  currentID = 0;
  none = false;

  isEditor:boolean = false;
  isAdmin:boolean = false;
  isOwner:boolean = false;
  isManager:boolean = false;

  isCanView:boolean = false;

  billingenable:boolean = true;

  @Output() messageEvent = new EventEmitter<any>();

  constructor(
    private companyService: CompanyService,
    private otherService: OthersService,
    private activateRoute: ActivatedRoute,
    private router:Router,
    private data: DataService) {
      this.current = this.companyService.getDault();
      console.log("CUrrent: " + JSON.stringify(this.current));

    
      $(window).on('load resize', function() {
        if ($(this).width() < 1024 && !$('body').hasClass('sidebar-mini')) {
          //alert("11111")
          $('body').addClass('drawer-sidebar');
          $('#sidebar-collapse').slimScroll({
            height: '100%',
            railOpacity: '0.9',
          });
        }
        else {
          //alert("22222")
          $('body').removeClass('drawer-sidebar');
        }
      });

      $.fn.backdrop = function() {
        $(this).toggleClass('shined');
        $('body').toggleClass('has-backdrop');
        return $(this);
      };

      $('.backdrop').click(closeShined);

      function closeShined() {
        $('body').removeClass('has-backdrop');
        $('.shined').removeClass('shined');
      }
  }

  ngOnInit() {

    /*$(window).on('load resize scroll', function() {
      if ($(this).width() < 1080 && !$('body').hasClass('sidebar-mini')) {
        $('body').addClass('drawer-sidebar');
        $('#sidebar-collapse').slimScroll({
          height: '100%',
          railOpacity: '0.9',
        });
      }
      else {
        $('body').removeClass('drawer-sidebar');
      }
    });

    $.fn.backdrop = function() {
      $(this).toggleClass('shined');
      $('body').toggleClass('has-backdrop');
      return $(this);
    };

    $('.backdrop').click(closeShined);

    function closeShined() {
      $('body').removeClass('has-backdrop');
      $('.shined').removeClass('shined');
    }*/
  }

  ngAfterViewInit() {


    this.data.currentMessage.subscribe(message => {
      //this.message = message;
      //this.checkDefaultCompany();
      //console.log(" hallo: I am here " + message);
      this.defcomp = message;
      if (this.defcomp) {
        this.compname = this.defcomp.name;
        this.compid = this.defcomp.id;
      }
      else {

      }

      //console.log("nnnn " + this.compname);
      this.checkRoot();
    });
  }

  displayComList() {
    $('.pop-up-bg').toggle();

    if ($(".pop-up-bg").is(':visible')) {
      $("body").css("overflow-y","hidden");
    }
    else {
      $("body").css("overflow-y","scroll");
    }
  }

  
  checkDefaultCompany() {

    this.defcomp = this.companyService.getDault();

    if (this.currentID>0) {

      for(let m of this.listcomps) {

        if (m.id == this.currentID) {

          this.showsubmenu = true;
          this.defcomp = m;
          //alert(m.name)
          this.companyService.setDefault(m);
          this.compname = this.defcomp.name;
          //alert(this.defcomp.name)
          break;
        }

      }

      //return;
    }

    if (this.defcomp) {
      //alert(this.defcomp.name)
      if (this.listcomps) {
        if (this.listcomps.length > 0) {
          //console.log("Still got list ..lalllllll " + this.listcomps.length + " " + this.listcomps);
          this.compname = this.defcomp.name;
          this.showsubmenu = true;
          this.compid = this.defcomp.id;

          this.checkRoot();
        }
        else {
          console.log("No ... howwwwwwwwwwwww")
          this.showsubmenu = false;
          this.companyService.setDefault(null);
          this.defcomp = null;
        }
      }
      else {
         console.log("Nothing!!!!");
      }

    }
    else if (this.listcomps && this.listcomps.length > 0) {
      //console.log("Still got list ")
      this.defcomp = this.listcomps[0];
      this.companyService.setDefault(this.defcomp);
      this.showsubmenu = true;

      this.compname = this.defcomp.name;
      this.compid = this.defcomp.id;
      this.otherService.setCurrentComp(this.defcomp);
      this.checkRoot();
    }
    else {
      this.showsubmenu = false;
      this.linked = false;
    }


  }

  resetContent($event) {
    
  }


  checkRoot() {
      let roleid = this.defcomp.role_id;

      if (roleid == 1) {
          this.isOwner = true;
          this.isAdmin = false;
          this.isEditor = false;
          this.isManager = false;
      }
      else if (roleid == 2) {
        this.isOwner = false;
        this.isAdmin = true;
        this.isEditor = false;
        this.isManager = false;
      }
      else if (roleid == 3) {
        this.isOwner = false;
        this.isAdmin = false;
        this.isEditor = true;
        this.isManager = false;
      }
      else if (roleid == 4) {
        this.isOwner = false;
        this.isAdmin = false;
        this.isEditor = false;
        this.isManager = true;
      }
  }
}
